import Vue from "vue";
import App from "./App.vue";
import router from "./router";

// 引入jQuery、bootstrap
import $ from "jquery";
// 引入bootstrap样式
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import "@/styles/common.scss";

import { Drawer } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "animate.css";
Vue.use(Drawer);
Vue.prototype.$ = $;
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
